export default {
  data: {
    Videos: {
      name: 'VideoCard',
      dataKey: 'settings.fields',
      multi: true,
      presentation: {
        'list': 'Grid',
        'Slider 3D': 'Slider',
        'Slider': 'Slider',
        'player': 'SingleVideo',
        "SliderCoverFlow": "Slider",
        "SliderMulti": "Slider"
      }
    },
    ImageText: {
      name: 'ImageText',
      dataKey: 'settings.fields',
      multi: true,
      presentation: {
        'list': 'Grid',
        'Slider 3D': 'Slider',
        'Slider': 'Slider',
        'player': 'SingleVideo',
        "SliderCoverFlow": "Slider",
        "SliderMulti": "Slider"
      }
    },
    VideoBanner: {
      name: 'VideoBackground',
      dataKey: 'settings.fields',
      multi: false,
      presentation: {
        'FullGrid': 'FullGrid',
      }
    },
    TextGrid: {
      name: 'ColumnText',
      dataKey: 'settings.fields',
      multi: true,
      presentation: {
        'list': 'Grid',
        'Slider 3D': 'Slider',
        'Slider': 'Slider',
        'player': 'SingleVideo',
        "SliderCoverFlow": "Slider",
        "SliderMulti": "Slider"
      }
    },
    Html: {
      name: 'HtmlText',
      dataKey: 'settings.fields',
      multi: false,
      presentation: {
        'list': 'Grid',
        'Slider 3D': 'Slider',
        'Slider': 'Slider',
        'player': 'SingleVideo',
        "SliderCoverFlow": "Slider",
        "SliderMulti": "Slider"
      }
    },
    HeroImage: {
      name: 'HeroImage',
      dataKey: 'settings.fields',
      multi: false,
      presentation: {
        'list': 'Grid',
        'Slider 3D': 'Slider',
        'Slider': 'Slider',
        'player': 'SingleVideo',
        "SliderCoverFlow": "Slider",
        "SliderMulti": "Slider"
      }
    },
    Category: {
      name: 'Category',
      dataKey: 'settings.fields',
      multi: false,
      presentation: {
        'list': 'Grid',
        'Slider 3D': 'Slider',
        'Slider': 'Slider',
        'player': 'SingleVideo',
        "SliderCoverFlow": "Slider",
        "SliderMulti": "Slider"
      }
    },
    CoverCategory: {
      name: 'CoverCategory',
      dataKey: 'settings.fields',
      multi: false,
      presentation: {
          'list': 'Grid',
          'stack': 'StackGrid',
          'Slider 3D': 'Slider',
          'Slider': 'Slider',
          'player': 'SingleVideo',
          "SliderCoverFlow": "Slider",
          "SliderMulti": "Slider"
      }
    },
    Faq: {
      name: 'Faq',
      dataKey: 'settings.fields',
      multi: false,
      presentation: {
        'list': 'Grid'
      }
    },
    Promotions: {
      name: 'Promotions',
      dataKey: 'settings.fields',
      multi: true,
      presentation: {
        'Slider': 'Slider'
      }
    },
    VideoGrid: {
      name: 'VideoGrid',
      dataKey: 'settings.fields',
      multi: false,
      presentation: {
        'list': 'Grid',
        'Slider': 'Slider'
      }
    },
    VideoSingle: {
      name: 'VideoSingle',
      dataKey: 'settings.fields',
      multi: false,
      presentation: {
        'list': 'Grid'
      }
    }
  }
}
